import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { Redirect } from "react-router-dom"

// Packages
import Select from 'react-select';

// API
import * as API from '../../utils/api';
import { networkMessage, showToast } from '../../utils/helpers'

// Components
import AppCanvasLoader from '../../components/App/AppCanvasLoader';
import AppSectionHeader from '../../components/App/AppSectionHeader';
import ObjectList from '../../components/ObjectList/ObjectList';
import CounterofferModal from '../../components/App/Modals/Admin/CounterofferModal';

class AdminOffers extends Component {

  state = {
    offers: [],
    isLoading: true,
    input: {
      search: {
        value: ""
      },
      offer_type: {
        value: "pending"
      }
    },
    selectedOfferForCounter: '',
    showCounterOfferModal: '',
    error: {
      hasAnyError: false,
      statusCode: 200
    }
  }

  componentDidMount() {
    let newPartialInput = { ...this.state.input };
    let offer_type = 'pending'
    if (newPartialInput.offer_type.value === undefined || newPartialInput.offer_type.value === null || newPartialInput.offer_type.value === '') {
      offer_type = 'pending'
    } else {
      offer_type = newPartialInput.offer_type.value
    }
    API.getOfferList(this.props.user, offer_type).then(data => {
     if (((typeof data != 'undefined') || (data != null)) && !data.error) {
        this.setState(state => ({
          ...state,
          offers: data.offers,
          isLoading: false
        }));
      } else {
        this.setState(state => ({
          ...state,
          error: {
            hasAnyError: true,
            statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
          }
        }))
      }
    });
  }

  handleInputChange(newPartialInput) {
    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        ...newPartialInput,
      }
    }),
      () => { this.handleSearch() }
    )
  }

  setOfferData = (dataSet = []) => {
    this.setState(state => ({
      ...state,
      offers: dataSet,
      isLoading: false
    }))
  }

  handleSearch = () => {
    let queryString = this.state.input.search.value;
    let offer_type = this.state.input.offer_type.value;
    if (offer_type === undefined || offer_type === null || offer_type === '') {
      offer_type = 'pending'
    }
    if (queryString) {
      API.adminOfferSearch(this.props.user, 'offers', offer_type, queryString).then(data => {
        if (((typeof data != 'undefined') || (data != null)) && (data.results)) {
          this.setOfferData(data.results);
        } else {
          this.setOfferData();
        }
      });
    } else {
      this.setOfferData(this.state.offers);
    }
  }

  handleRowActionClick = (event) => {
    const actionBehavior = event.target.getAttribute('data-behavior');
    const offerId = event.target.getAttribute('data-target');
    const { user } = this.props;
    let amount = 0;
    let message = '';
    for (var i in this.state.offers) {
      let offerIdState = this.state.offers[i].id;
      if (offerId == offerIdState) {
        amount = this.state.offers[i].total_in_dollars_as_currency
        break;
      }
    }

    message = 'Are you sure you want to accept the offer of $' + amount + ' for this account.'



    switch (actionBehavior) {
      case "offer-accept":
        confirmAlert({
          //title: 'Confirm to submit',
          message: message,
          buttons: [
            {
              label: 'Yes',
              onClick: () => this.handleAcceptOffer(offerId)
            },
            {
              label: 'Go Back',
              onClick: () => ''
            }
          ]
        })
        break;
      case "offer-counter":
        this.handleCounterOffer(offerId);
        break;
      case "offer-reject":
        API.adminRejectOffer(user, offerId).then(data => {
         if (((typeof data != 'undefined') || (data != null)) && !data.error) {
            this.handleOfferActionResponse(data, offerId, actionBehavior);
          } else {
            this.setState(state => ({
              ...state,
              error: {
                hasAnyError: true,
                statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
              }
            }))
          }
        });
        break;
      default:
        alert('Error: Something went wrong');
    }
  }

  handleAcceptOffer = (offerId) => {
    const { user } = this.props;
    API.adminAcceptOffer(user, offerId).then(data => {
     if (((typeof data != 'undefined') || (data != null)) && !data.error) {
        this.handleOfferActionResponse(data, offerId, "offer-accept");
      } else {
        this.setState(state => ({
          ...state,
          error: {
            hasAnyError: true,
            statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
          }
        }))
      }
    });
  }

  handleCounterOffer = (offerId) => {
    let selectedOffer = this.getOffer(offerId);
    let modalProps = {};

    if (selectedOffer.number_of_payments === 1) {
      this.setState(state => ({
        ...state,
        showCounterOfferModal: true,
        selectedOfferForCounter: selectedOffer
      }))
    } else {
      modalProps = {
        message: "This offer cannot be countered because the consumer wants to make multiple payments. Please accept or reject this offer."
      }
      this.props.updateModalState(true, 'ERROR', modalProps);
    }
  }

  handleOfferActionResponse = (data, offerId, actionBehavior) => {
    if (data.message) {
      this.hideCounterOfferModal();
      if (data.paymentComplete) {
        this.props.updateModalState(true, 'ADMIN_OFFER_ACCEPTED_AND_SETTLED');
        this.componentDidMount();
      } else {
        this.props.updateModalState(true, 'ERROR', { message: data.message })
      }
    } else {
      let optionalProps = {}
      let { offers } = this.state;
      let selectedOffer = this.getOffer(offerId);

      switch (actionBehavior) {
        case "offer-accept":
          optionalProps = {
            user: selectedOffer.user,
            offer: selectedOffer
          }
          this.props.updateModalState(true, 'OFFER_ACCEPTED', optionalProps);
          break;
        case "offer-counter":
          optionalProps = {
            user: selectedOffer.user,
            appEmail: this.props.appEmail
          }
          this.props.updateModalState(true, 'COUNTEROFFER_SENT', optionalProps);
          this.hideCounterOfferModal();
          break;
        case "offer-reject":
          optionalProps = {
            user: selectedOffer.user
          }
          this.props.updateModalState(true, 'OFFER_REJECTED', optionalProps);
          break;
        default:
          alert('Error: Something went wrong');
      }

      let newOffers = offers.filter((offer) => {
        return offer.id !== parseInt(offerId, 10);
      });

      this.setState(state => ({
        ...state,
        offers: newOffers
      }))
    }
  }

  hideCounterOfferModal = () => {
    this.setState(state => ({
      ...state,
      showCounterOfferModal: false,
    }))
  }

  getOffer = (offerId) => {
    let { offers } = this.state;

    let selectedOffer = offers.filter((offer) => {
      return offer.id === parseInt(offerId, 10);
    });

    return selectedOffer[0];
  }

  getOffersObjectListData = () => {
    const { offers } = this.state;
    let disableMenuClass = 'overflowMenu';
    if (this.state.input.offer_type.value !== 'pending') {
      disableMenuClass = 'inactive remove-inactive-menu';
    }
    return {
      headings: [
        'Consumer / Creditor',
        'Debt Amount',
        'Offer Amount',
        'Payment Type'
      ],
      columns: offers.map((offer) => {
        var paymentTypeTitle = ""

        if (offer.number_of_payments === 1) {
          paymentTypeTitle = "One Time"
        } else {
          paymentTypeTitle = `${offer.number_of_payments} Month`
        }

        return {
          primaryColumn: {
            title: offer.user.first_name + ' ' + offer.user.last_name,
            secondaryInfo: offer.creditor_name
          },
          secondaryColumns: [
            {
              title: `$${offer.original_debt_in_dollars}`
            },
            {
              title: `$${offer.total_in_dollars_as_currency}`
            },
            {
              title: paymentTypeTitle
            }
          ],
          rowType: disableMenuClass,
          rowActions: offer.number_of_payments === 1 ? [
            {
              title: 'Accept Offer',
              optionalClasses: 'alert-positive',
              dataBehavior: 'offer-accept',
              dataTarget: offer.id
            },
            {
              title: 'Counter Offer',
              dataBehavior: 'offer-counter',
              dataTarget: offer.id

            },
            {
              title: 'Reject Offer',
              optionalClasses: 'alert',
              dataBehavior: 'offer-reject',
              dataTarget: offer.id
            }
          ] :
            [
              {
                title: 'Accept Offer',
                optionalClasses: 'alert-positive',
                dataBehavior: 'offer-accept',
                dataTarget: offer.id
              },
              {
                title: 'Reject Offer',
                optionalClasses: 'alert',
                dataBehavior: 'offer-reject',
                dataTarget: offer.id
              }
            ]
        }
      })
    }
  }


  handleSelectChange = (newPartialInput) => {
    if (newPartialInput.offer_type.value !== undefined || newPartialInput.offer_type.value !== null || newPartialInput.offer_type.value !== '') {
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          ...newPartialInput,
        }
      }))
      API.getOfferList(this.props.user, newPartialInput.offer_type.value).then(data => {
       if (((typeof data != 'undefined') || (data != null)) && !data.error) {
          this.setOfferData(data.offers);
        } else {
          this.setState(state => ({
            ...state,
            error: {
              hasAnyError: true,
              statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
            }
          }))
        }
      })
    } else {
      console.log('something went wrong');
    }
  }


  render() {
    const { appName, user } = this.props;
    const {
      input,
      isLoading,
      showCounterOfferModal,
      selectedOfferForCounter,
      error
    } = this.state;

    const modal = showCounterOfferModal ? (
      <CounterofferModal
        user={user}
        handleOfferActionResponse={this.handleOfferActionResponse}
        offerRecipient={selectedOfferForCounter.user}
        offer={selectedOfferForCounter}
        hideModal={this.hideCounterOfferModal}
        updateModalState={this.props.updateModalState}
      />
    ) : null;

    let sectionHeaderUtilities = (
      <div className="app-section-header-utilities">
        <div className="admin-search-input-container">
          <input
            type="text"
            name="search"
            placeholder="Search"
            value={input.search.value}
            className="admin-search-input"
            onChange={event => this.handleInputChange(
              { search: { value: event.target.value } }
            )}
          />
          <span className="search-icon"/>
        </div>
      </div>
    )


    let offerFilterAction = (

      <div className="app-section-header-offer-filter">
        <label htmlFor="name offer-select-label">Filter By: </label>
        <Select
          inputProps={{ autoComplete: 'none', autoCorrect: 'off', spellCheck: 'off' }}
          className="form-select"
          name="offer_type"
          value={input.offer_type.value}
          placeholder="Select Offer"
          options={[
            { "value": "pending", "label": "Pending" },
            { "value": "accepted", "label": "Accepted" },
            { "value": "rejected", "label": "Rejected" },
            { "value": "countered", "label": "Countered" },
            { "value": "closed", "label": "Closed" }
          ]}
          resetValue=""
          onChange={event => this.handleSelectChange({ offer_type: { value: event ? event.value : '', hasError: false } })}
        />

      </div>
    )

    if (error.hasAnyError) {
      if (error.statusCode == 500) {
        showToast();
        this.setState({
          error:{
            ...this.state.error,
            hasAnyError: false,
            statusCode: 200
          }
        });
      } else if (error.statusCode == 401) {
        return <Redirect to={{ pathname: '/sign-out' }} />
      } else {
        this.props.updateModalState(true, 'OTHER_ERROR', true)
        return <Redirect to={{ pathname: '/sign-out' }} />
      }
    }

    return isLoading
      ? (
        <AppCanvasLoader />
      )
      : (
        <div>
          <Helmet>
            <title>{appName} | Offers</title>
          </Helmet>
          <AppSectionHeader
            title="Offers"
            offerFilter={offerFilterAction}
            utilities={sectionHeaderUtilities}
          />
          {this.state.offers ? this.state.offers.length > 0 ? (
            <ObjectList
              data={this.getOffersObjectListData()}
              rowActionClick={(event) => this.handleRowActionClick(event)}
            />
          ) : (
              this.state.input.search.value.length ? (
                <div className="admin-admins-empty-state">
                  <p>
                    No results found for:
                    </p>
                  <h3 className="admin-admins-empty-state-heading">
                    {this.state.input.search.value}
                  </h3>
                </div>
              ) : (
                  <div className="admin-admins-empty-state">
                    <h3 className="admin-admins-empty-state-heading">
                      Currently no offers!
                    </h3>
                    <p>
                      There are currently no submitted offers for you to review.
                    </p>
                  </div>
                )
            ) : ''}
          {showCounterOfferModal ? modal : ''}
          {showCounterOfferModal ? (
            <div className="curtain" ></div>
          ) : ''}
        </div>
      );
  }
}

export default AdminOffers;
